import React, { useCallback } from "react";
import { withFormik } from 'formik';
import * as Yup from "yup";

// core components
import { Input } from "stories/forms";
import { Button, Typography } from "stories/components"
import { Card, CardBody, CardHeader, Col, Row } from "stories/layout"
import { httpChangePassword } from "services/users";

const PasswordResetForm = (props) => {
  const {
    values,
    touched,
    errors,
    handleChange,
    handleBlur,
    handleSubmit,
    isSubmitting,
    validateForm,
  } = props;
  
  const {
    t
  } = props;
  
  const getFormikInputProps = useCallback(
    name => ({
      name,
      value: values[name],
      error: Boolean(touched[name] && errors[name]),
      errorText: touched[name] ? errors[name] : "",
      onBlur: handleBlur,
      onChange: handleChange
    }),
    [values, errors, touched, handleBlur, handleChange]
  );
  
  return (
    <Card>
      <CardHeader className="bg-transparent pt-5 pb-1">
        <div className="text-center text-muted mb-4">
          <Typography variant="h2" className="mb-2">{t('reset_password_title', 'Aseta uusi salasana')}</Typography>
          <Typography variant="p"></Typography>
        </div>
      </CardHeader>
      <CardBody className="bg-transparent px-lg-5 py-lg-5">
        <Row>
          <Col className="mb-3">
            <Input
              {...getFormikInputProps("password")}
              label={t("new_password_input", "Uusi salasana")}
              type="password"
              required
            />
          </Col>
        </Row>
        
        <Row>
          <Col className="mb-3">
            <Input
              {...getFormikInputProps("password2")}
              label={t("password_again_input", "Uusi salasana uudelleen")}
              type="password"
              required
            />
          </Col>
        </Row>
        
        <div className="text-center text-muted mb-4 mt-4">
          <Button variant="secondary" disabled={isSubmitting} onClick={() => validateForm().then(() => handleSubmit())}>{t("save_button", "Tallenna")}</Button>
          { Boolean(errors["general"]) && <Typography className="text-danger">{errors["general"]}</Typography> }
        </div>
      </CardBody>
    </Card>
  );
}

const defaultValues = {
  password: '',
  password2: '',
}

const PasswordResetFormWithFormik = withFormik({
  validateOnMount: true,
  mapPropsToValues: props => {
    const { preSetValues } = props;
    if (preSetValues) {
      return preSetValues;
    } else {
      return defaultValues
    }
  },
  validationSchema: props => {
    const {t} = props;
    const required = t("required_field", "Kenttä on pakollinen");
    
    return Yup.object().shape({
      password: Yup.string().required(required),
      password2: Yup.string().required(required),
    });
  },
  validate: (values, props) => {
    const {t} = props;
    const errors = {};
    
    if (values?.password && values?.password2 && values?.password != values?.password2) {
      errors.password = t("passwords_not_match", "Salasanat eivät täsmää")
    }
   
    return errors;
  },
  handleSubmit: (values, { setSubmitting, setErrors, props }) => {
    const {t} = props;
    let data = {
      data: {
        new_password: values?.password,
        check_password: values?.password2,
      }
    };
    
    httpChangePassword("me", data).then(res => {
      setSubmitting(false);
      if (res?.status === 200) {
        localStorage.removeItem("refreshToken");
        localStorage.removeItem("accessToken");
        props.notify({ title:t("password_title", "Salasana"), message:t("password_updated_success", "Päivitetty onnistuneesti")})
        props.history("/auth/login")
      }
      else {
        if (res?.data?.User) {
          setErrors({
            general: t(res?.data?.User)
          })
        }
        else {
          setErrors({
            general: JSON.stringify(res?.data)
          })
        }
      }
    }, error => {
      setSubmitting(false);
      if (error?.data?.detail) {
        setErrors({
          general: error?.data?.detail,
        })
      }
      else {
        setErrors({
          general: t("unknown_error", "Tuntematon virhe. Yritä myöhemmin uudelleen tai ota yhteys tukeen.")
        })
      }
    })
  },
  displayName: "PasswordResetForm"
})(PasswordResetForm);

export default PasswordResetFormWithFormik; 